module.exports = __webpack_public_path__ + "07_mole.113a9cef.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/07_mole.png
// module id = 1nSW
// module chunks = 0